import CssBaseline from "@mui/material/CssBaseline";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import { Metadata } from "../../components/common/Metadata/Metadata";
import { SnackbarProvider } from "../SnackbarProvider/SnackbarProvider";

const BaseContainer = ({ children }: React.PropsWithChildren<unknown>) => (
  <>
    <CssBaseline />
    <Metadata />
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <SnackbarProvider>{children}</SnackbarProvider>
    </LocalizationProvider>
  </>
);

export { BaseContainer };
